const TabBar = ({ children }) => {
    return <div className="tab-bar">{children}</div>;
};

export default TabBar;
